// Account Key for the Dropbox Pulse App in local storage
export const SPRITES_GPT_ACCOUNT_KEY = 'sprites_gpt_account';

// Route paths
export const ROUTE_PATHS = {
  HOME: '/home',
  FEEDBACK: '/feedback',
  MANAGER_FEEDBACK: '/manager_feedback',
  CAREER_FRAMEWORK: '/career_framework',
  WAITLIST: '/waitlist',
  PROFILE: '/my-profile',
  ADMIN: '/admin',
};

// Emails permanently excluded from Google Analytics tracking.
// Users on this list will never have their actions recorded in GA,
// regardless of proxying state.
export const ANALYTICS_BLOCKLIST: string[] = [
  'tafolayan@dropbox.com',
  'gcheng@dropbox.com',
  'caseyferguson@dropbox.com',
];

export const ADMINS = [
  'abraham@dropbox.com',
  'alyssa@dropbox.com',
  'caseyferguson@dropbox.com',
  'gcheng@dropbox.com',
  'gherringer@dropbox.com',
  'hasini@dropbox.com',
  'kdavis@dropbox.com',
  'mgallifrey@dropbox.com',
  'ofer@dropbox.com',
  'sarahtyler@dropbox.com',
  'tafolayan@dropbox.com',
  'wyattrichter@dropbox.com',
  'ysalamini@dropbox.com',
  'lmastronardi@dropbox.com',
  'ellexing@dropbox.com',
  'mdelrio@dropbox.com',
];
